import * as _4 from 'lodash4';
import { ICommand } from 'core-ts-types';
import { ISection } from '../../interfaces/scheduler_interfaces';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { SectionDetailsQuery } from '../section_details/queries/section_details_query';
import { IFormattedSectionTime, SectionInfoServant } from '../../views/sections/servants/section_info_servant';
import { ScheduleSectionFacade } from '../../views/registration/facades/schedule_section_facade';
import { SwapFacade } from '../../swap/facades/swap_facade';

class SectionConflictPromptCtrl {
  private openPrompt: boolean = false;
  private section: ISection;
  private isPermissionPinsFeatureEnabled = false;
  private sectionPins = {};
  private openBound: () => void;
  private closeBound: () => void;
  private locationAndTimes: IFormattedSectionTime[];

  constructor(
    private $state: ng.ui.IStateService,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngSectionDetailsQuery: SectionDetailsQuery,
    private ngSectionInfoServant: SectionInfoServant,
    private ngSwapFacade: SwapFacade,
    private ngScheduleSectionFacade: ScheduleSectionFacade
  ) {}
  $onInit() {
    this.closeBound = this.closePromptFn.bind(this);
    this.openBound = this.openPromptFn.bind(this);
    this.ngComponentCommunicatorService.subscribe('OPEN_CONFLICT_PROMPT', this.openBound);
    this.ngComponentCommunicatorService.subscribe('CLOSE_CONFLICT_PROMPT', this.closeBound);
  }
  closePromptFn() {
    this.openPrompt = false;
  }
  openPromptFn() {
    this.openPrompt = true;
    this.updateProperties();
  }
  updateProperties() {
    this.section = this.ngSectionDetailsQuery.result.section;
    this.locationAndTimes = this.ngSectionInfoServant.calculateSectionTimes(this.section);
  }
  scheduleConflictSection() {
    const isSwapMode = _4.includes(this.$state.current.name || '', 'swap');
    if (isSwapMode) {
      return this.ngSwapFacade.saveSwapToAndRedirect(this.section);
    }
    return this.ngScheduleSectionFacade.scheduleSection(this.section);
  }
  $onDestroy() {
    this.ngComponentCommunicatorService.release('OPEN_CONFLICT_PROMPT', this.openBound);
    this.ngComponentCommunicatorService.release('CLOSE_CONFLICT_PROMPT', this.closeBound);
  }
}

class SectionConflictPrompt implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      section: '<'
    };
    this.controller = SectionConflictPromptCtrl;
    this.templateUrl = 'capability-ng-scheduler/src/components/section_conflict_prompt/section_conflict_prompt.html';
  }
}
angular.module('capability-ng-scheduler').component('sectionConflictPrompt', new SectionConflictPrompt());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/components/section_conflict_prompt/section_conflict_prompt.ts